import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCashRegister,
  faChartLine,
  faCloudUploadAlt,
  faPlus,
  faRocket,
  faTasks,
  faUserShield,
  faCalendar,
} from "@fortawesome/free-solid-svg-icons";
import {
  Col,
  Row,
  Button,
  Dropdown,
  ButtonGroup,
} from "@themesberg/react-bootstrap";

import {
  CounterWidget,
  CircleChartWidget,
  BarChartWidget,
  TeamMembersWidget,
  ProgressTrackWidget,
  RankingWidget,
  SalesValueWidget,
  SalesValueWidgetPhone,
  AcquisitionWidget,
} from "../../components/Widgets";
import { PageVisitsTable } from "../../components/Tables";
import { trafficShares, totalOrders } from "../../data/charts";
import { DashboardWidget } from "../../components/DashboardWidget";
import { useSelector, useDispatch } from "react-redux";
import { getSahakariDashboardStats } from "../../redux/actions/sahakari";
import CustomDashboardLoader from "../../components/CustomDashboardLoader";

export default () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const {
    userData: { role },
  } = useSelector((state) => state.user);
  const { sahakariStats } = useSelector((state) => state.sahakari);

  useEffect(() => {
    if (role === "ROLE_ADMIN") {
      setIsLoading(true);
      dispatch(getSahakariDashboardStats()).then(() => setIsLoading(false));
    }
  }, []);

  return (
    <>
      {/* <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <Dropdown className="btn-toolbar">
          <Dropdown.Toggle
            as={Button}
            variant="primary"
            size="sm"
            className="me-2"
          >
            <FontAwesomeIcon icon={faPlus} className="me-2" />
            New Task
          </Dropdown.Toggle>
          <Dropdown.Menu className="dashboard-dropdown dropdown-menu-left mt-2">
            <Dropdown.Item className="fw-bold">
              <FontAwesomeIcon icon={faTasks} className="me-2" /> New Task
            </Dropdown.Item>
            <Dropdown.Item className="fw-bold">
              <FontAwesomeIcon icon={faCloudUploadAlt} className="me-2" />{" "}
              Upload Files
            </Dropdown.Item>
            <Dropdown.Item className="fw-bold">
              <FontAwesomeIcon icon={faUserShield} className="me-2" /> Preview
              Security
            </Dropdown.Item>

            <Dropdown.Divider />

            <Dropdown.Item className="fw-bold">
              <FontAwesomeIcon icon={faRocket} className="text-danger me-2" />{" "}
              Upgrade to Pro
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>

        <ButtonGroup>
          <Button variant="outline-primary" size="sm">
            Share
          </Button>
          <Button variant="outline-primary" size="sm">
            Export
          </Button>
        </ButtonGroup>
      </div> */}
      {/* <Col xs={12} className="mb-4 d-none d-sm-block">
          <SalesValueWidget
            title="Sales Value"
            value="10,567"
            percentage={10.57}
          />
        </Col>
        <Col xs={12} className="mb-4 d-sm-none">
          <SalesValueWidgetPhone
            title="Sales Value"
            value="10,567"
            percentage={10.57}
          />
        </Col> */}
      {isLoading ? (
        <CustomDashboardLoader />
      ) : (
        <Row className="justify-content-md-center">
          <Col xs={12} sm={6} xl={4} className="mb-4">
            <DashboardWidget
              category="My Customers"
              title={`${sahakariStats?.activeCustomers ?? 0} Active`}
              title2={`${
                sahakariStats?.unassignedActiveCustomers ?? 0
              } Unassigned`}
              period="2021"
              percentage={18.2}
              icon={faUserShield}
              iconColor="shape-secondary"
            />
          </Col>

          <Col xs={12} sm={6} xl={4} className="mb-4">
            <DashboardWidget
              category="My Collectors"
              title={`${sahakariStats?.activeCollectors ?? 0} Active`}
              title2={`${sahakariStats?.inActiveCollectors ?? 0} InActive`}
              period="Feb 1 - Apr 1"
              percentage={28.4}
              icon={faCashRegister}
              iconColor="shape-tertiary"
            />
          </Col>

          <Col xs={12} sm={6} xl={4} className="mb-4">
            <DashboardWidget
              category="Todays Status"
              title={`${sahakariStats?.todaysSubmittedBatchCount ?? 0} batches submitted`}
              title2={`${sahakariStats?.todaysTransactionCount ?? 0} total transactions`}
              period="Feb 1 - Apr 1"
              percentage={28.4}
              icon={faCalendar}
              iconColor="shape-tertiary"
            />
          </Col>
          <Col xs={12} sm={6} xl={4} className="mb-4">
            <DashboardWidget
              category="Todays Deposit"
              title={`${sahakariStats?.todaysDepositCount ?? 0} deposits`}
              title2={`Nrs. ${sahakariStats?.todaysDepositAmount ?? 0} collected`}
              period="Feb 1 - Apr 1"
              percentage={28.4}
              icon={faCalendar}
              iconColor="shape-tertiary"
            />
          </Col>
          <Col xs={12} sm={6} xl={4} className="mb-4">
            <DashboardWidget
              category="Withdrawl Requests"
              title={`${sahakariStats?.totalWithdrawCount ?? 0} requests`}
              title2={`Nrs. ${sahakariStats?.totalWithdrawAmount?? 0} requests`}
              period="Feb 1 - Apr 1"
              percentage={28.4}
              icon={faCalendar}
              iconColor="shape-tertiary"
            />
          </Col>
          <Col xs={12} sm={6} xl={4} className="mb-4">
            <DashboardWidget
              category="Pending Batches"
              title={`${sahakariStats?.pendingBatchCount ?? 0} pending batches`}
              title2={`Nrs. ${sahakariStats?.pendingBatchAmount ?? 0} pending amount`}
              period="Feb 1 - Apr 1"
              percentage={28.4}
              icon={faCalendar}
              iconColor="shape-tertiary"
            />
          </Col>
        </Row>
      )}

      {/* <Row>
        <Col xs={12} xl={12} className="mb-4">
          <Row>
            <Col xs={12} xl={8} className="mb-4">
              <Row>
                <Col xs={12} className="mb-4">
                  <PageVisitsTable />
                </Col>

                <Col xs={12} lg={6} className="mb-4">
                  <TeamMembersWidget />
                </Col>

                <Col xs={12} lg={6} className="mb-4">
                  <ProgressTrackWidget />
                </Col>
              </Row>
            </Col>

            <Col xs={12} xl={4}>
              <Row>
                <Col xs={12} className="mb-4">
                  <BarChartWidget
                    title="Total orders"
                    value={452}
                    percentage={18.2}
                    data={totalOrders}
                  />
                </Col>

                <Col xs={12} className="px-0 mb-4">
                  <RankingWidget />
                </Col>

                <Col xs={12} className="px-0">
                  <AcquisitionWidget />
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row> */}
    </>
  );
};
